import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60488381"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "brush-map__title" }, "4. Выбранные ёршики", -1))
const _hoisted_2 = { class: "selected-brushes__content" }
const _hoisted_3 = { class: "selected-brushes__title" }
const _hoisted_4 = { class: "selected-brushes__items" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  fill: "none",
  height: "9",
  viewBox: "0 0 9 9",
  width: "9",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "4.60914",
  cy: "4.261",
  fill: "#8D8D8D",
  r: "3.84352"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M5.64497 5.41406L3.45561 3.10795M3.57236 5.41406L5.76172 3.10795",
  stroke: "white",
  "stroke-linecap": "round",
  "stroke-width": "0.683292"
}, null, -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "selected-brushes__bottom"
}
const _hoisted_11 = { class: "selected-brushes__title" }
const _hoisted_12 = { class: "selected-brushes__items" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 0,
  fill: "none",
  height: "9",
  viewBox: "0 0 9 9",
  width: "9",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "4.60914",
  cy: "4.261",
  fill: "#8D8D8D",
  r: "3.84352"
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M5.64497 5.41406L3.45561 3.10795M3.57236 5.41406L5.76172 3.10795",
  stroke: "white",
  "stroke-linecap": "round",
  "stroke-width": "0.683292"
}, null, -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { BrushMapTeeth } from '@/pages/BrushMapPage/brushMapTeeth'
import { BrushMapAddedBrushes } from '@/pages/BrushMapPage/brushMapAddedBrushes'
import { BrushMapFirm } from '../brushMapFirm'
import { BrushMapController } from '../brushMapController'

interface Props {
  brushMapTeeth: BrushMapTeeth
  brushMapFirm: BrushMapFirm
  brushMapBrushes: BrushMapAddedBrushes
  brushMapController: BrushMapController
}


export default /*#__PURE__*/_defineComponent({
  props: {
    brushMapTeeth: null,
    brushMapFirm: null,
    brushMapBrushes: null,
    brushMapController: null
  },
  setup(__props: any) {

const props = __props as {
  brushMapTeeth: BrushMapTeeth
  brushMapFirm: BrushMapFirm
  brushMapBrushes: BrushMapAddedBrushes
  brushMapController: BrushMapController
}



const route = useRoute()
const isPreviewMode = computed(() => route.query['view-mode'] === '1')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'selected-brushes_preview': _unref(isPreviewMode) }, "selected-brushes"])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(__props.brushMapFirm.firm.firstGroup), 1),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.brushMapBrushes.firstGroupBrushes, (brush) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "selected-brushes__item",
            onClick: ($event: any) => (__props.brushMapController.deleteAddedBrushFromFirstGroup(brush))
          }, [
            _createElementVNode("div", {
              style: _normalizeStyle({ background: brush.color }),
              class: "selected-brushes__circle"
            }, null, 4),
            _createElementVNode("span", null, _toDisplayString(brush.colorName), 1),
            (!_unref(isPreviewMode))
              ? (_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_9))
              : _createCommentVNode("", true)
          ], 8, _hoisted_5))
        }), 256))
      ]),
      (__props.brushMapFirm.firm.secondGroup !== 'none')
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("h3", _hoisted_11, _toDisplayString(__props.brushMapFirm.firm.secondGroup), 1),
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.brushMapBrushes.secondGroupBrushes, (brush) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "selected-brushes__item",
                  onClick: ($event: any) => (__props.brushMapController.deleteAddedBrushFromSecondGroup(brush))
                }, [
                  _createElementVNode("div", {
                    style: _normalizeStyle({ background: brush.color }),
                    class: "selected-brushes__circle"
                  }, null, 4),
                  _createElementVNode("span", null, _toDisplayString(brush.colorName), 1),
                  (!_unref(isPreviewMode))
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_14, _hoisted_17))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_13))
              }), 256))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})